var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBakery15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "53.000000pt",
    height: "53.000000pt",
    viewBox: "0 0 53.000000 53.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,53.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210 385 c-10 -13 -11 -33 -1 -103 14 -95 22 -112 56 -112 34 0 42 17 56 112 14 105 8 118 -56 118 -26 0 -47 -6 -55 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 325 c-3 -9 0 -43 7 -75 12 -59 13 -60 46 -60 39 0 42 12 23 100 -10 46 -13 50 -40 50 -18 0 -32 -6 -36 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 290 c-19 -88 -16 -100 23 -100 33 0 34 1 46 60 15 72 10 90 -29 90 -27 0 -30 -4 -40 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 241 c-5 -11 -10 -33 -10 -50 0 -26 4 -31 24 -31 33 0 39 13 31 60 -7 43 -28 53 -45 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 220 c-8 -47 -2 -60 31 -60 20 0 24 5 24 31 0 71 -44 95 -55 29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBakery15);
export default __webpack_public_path__ + "static/media/bakery-15.7b8d50de0602509e56131a5ee2275d86.svg";
export { ForwardRef as ReactComponent };